import { get, post } from "../client";
import { ALL_PLANS, SUBSCRIBE } from "../routes";

export default {
  all_plans: async () => await get(ALL_PLANS),

  subscribe: async (data) => await post(SUBSCRIBE, data),
};
